import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_BIZ_PATH = process.env.VUE_APP_BIZ_PATH

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 查询工厂列表
     */
    // eslint-disable-next-line no-unused-vars
    async getFactoryList({ commit }, query) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/factory/list`;
        const result = await request.get(url, {params:query});
        //获取服务返回数据
        return result;
    },

    // 查询工厂详细
    async getFactory({ commit }, { id }) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/factory/${id}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result;
    },

    // 添加工厂
    async addFactory(state, params) {
        let url = `${VUE_APP_BIZ_PATH}/enterprise/factory`;
        const result = await request.post(url, params);
        return result;
    },
    // 修改工厂
    async editFactory(state, params) {
        let url = `${VUE_APP_BIZ_PATH}/enterprise/factory`;
        const result = await request.put(url, params);
        return result;
    },
    // 删除工厂
    async deleteFactory({ commit }, { ids }){
        let url = `${VUE_APP_BIZ_PATH}/enterprise/factory/${encodeURIComponent(ids)}`;
        const result = await request.delete(url);
        return result;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }